/* KHC header search bridge.
   The visible search box has no name="q" (so third-party search apps do not attach their own panel to it).
   khc.js drives a hidden name="q" field; this file mirrors typing into that field and sends focus to the visible box. */
(function () {
  'use strict';
  function wire() {
    var box = document.querySelector('[data-khc-search]');
    if (!box || box.getAttribute('data-bridge')) return;
    var vis = box.querySelector('input[data-khc-q]');
    var hid = box.querySelector('input[data-khc-qval]');
    if (!vis || !hid) return;
    box.setAttribute('data-bridge', '1');
    hid.focus = function () { vis.focus(); };
    vis.addEventListener('input', function () {
      hid.value = vis.value;
      hid.dispatchEvent(new Event('input', { bubbles: true }));
    });
    if (vis.form) vis.form.addEventListener('submit', function () { hid.value = vis.value; });
  }
  if (document.readyState !== 'loading') wire(); else document.addEventListener('DOMContentLoaded', wire);
  document.addEventListener('shopify:section:load', function () { setTimeout(wire, 0); });

  /* Checkout hand-off: block repeat clicks while the browser leaves for checkout */
  document.addEventListener('submit', function (e) {
    var f = e.target, sub = e.submitter;
    if (!f || !sub || sub.name !== 'checkout') return;
    if (f.getAttribute('data-khc-busy')) { e.preventDefault(); return; }
    f.setAttribute('data-khc-busy', '1');
    sub.classList.add('is-loading'); sub.setAttribute('aria-busy', 'true');
    setTimeout(function () { f.removeAttribute('data-khc-busy'); sub.classList.remove('is-loading'); sub.removeAttribute('aria-busy'); }, 10000);
  }, true);
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    Array.prototype.forEach.call(document.querySelectorAll('form[data-khc-busy]'), function (f) { f.removeAttribute('data-khc-busy'); });
    Array.prototype.forEach.call(document.querySelectorAll('.cart__checkout-button.is-loading'), function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
  });
})();
